<!--配件入库用弹窗-->
<template>
  <el-dialog title="配件选择" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height" style="display:flex">
          <!-- 左边------- 树型结构 -->
          <div class="left_tree">

            <div
              style="padding: 5px;margin: 2px 8px;border: 1px solid #ededed;">
              <div class="title" @click="handleNodeClick()">
                <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
                     version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
                  <path
                    d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
                    fill="#1296db" p-id="2888"></path>
                </svg>

                <span>商品分类</span>
              </div>
              <el-input placeholder="关键字过滤" v-model="filterText">
              </el-input>

              <div style="overflow: auto; height: 312px">
              <el-tree class="tree-line" :data="data" lazy :load="loadChildNode" :props="defaultProps"
                       @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree" v-if="isRouterAlive">
              </el-tree>
              </div>
            </div>
          </div>
          <div class="table_main" style="height: 400px!important;" v-if="isShow">
            <vxe-grid ref="table-m1" height="390"
                      class="is-pointer" v-bind="vxeOption"
                      @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle"
                      @checkbox-change="addDataTable"
                      @checkbox-all="checkAll"
                      @cell-dblclick="checkWithSubmit"
            >

              <template #form>

                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData1" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item title="配件名称:" field="name">
                    <template v-slot>
                      <el-input v-model="formData1.partsName" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="配件编码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData1.partsCode" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="配件型号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData1.partsSpec" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                </vxe-form>
                <div class="clearfix screen-btns">
                  <div class="fr" style="display: inline-block;
    float: right;
    margin-top: -39px;">
                    <!-- <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"
                      status="primary" plain>重置</vxe-button> -->
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索
                    </vxe-button>
                  </div>
                </div>
              </template>

              <template #showStart="{row}">
                <span v-if="isSite">*</span>
                <span v-else>{{row.price}}</span>
              </template>
              <template #showStart1="{row}">
                <span v-if="isSite">*</span>
                <span v-else>{{row.amount}}</span>
              </template>

              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <label id="labBtn" class="transverse">
      <div class="icon">
        <i class="el-icon-more"></i>
        <i class="el-icon-more"></i>
      </div>
    </label>
    <div class="multipleChoice">
      <el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top">
        <a class="allDel icon-quanbushanchu" @click="clearChecked()"></a>
      </el-tooltip>
      <div class="list">
        <div class="item" v-for="(checkRow, index) in checkRows" :key="checkRow.id">
          <p>{{ checkRow.partsName }}</p>
          <a class="el-icon-close" @click="clearTable1Select(index)"></a>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">

			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogPrimary" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {siteMixins} from "@/mixins/tabChang";
import store from "@/store";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'warehouseId', 'list'],
  mixins: [selectDialogMixins, siteMixins],
  components: {pager},

  created() {
    const userInfo = store.getters.userInfo;

    if (userInfo.snUserId) {
      console.log("userInfo58585858585555555555555"+userInfo.snUserId)
      this.isSite = true;
    }
    this.initSetting();
    this.formData.warehouseId = this.warehouseId
    if (this.list) {
      this.formData.excludePartsIdList = this.list.map(item => item.partsId)
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      isShow:true,
      type: 0,
      isSite: null,

      total: 0,
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100,300],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
        warehouseId: null,
        excludePartsIdList: [],
        partsCode: null,
        partsName: null,
        partsSpec: null,  // 型号
      },
      formData1: {
        partsCode: null,  // 编码,同厂商下惟一
        partsName: null,  // 名称
        partsSpec: null,  // 型号
      },
      showDialog: true,
      falseValue: false,



      columns: [
        {type: "checkbox", width: 40, fixed: 'left'},
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '配件编码', field: 'partsCode', width: 160,},
        {title: '配件名称', field: 'partsName', width: 160,},
        {title: '配件型号', field: 'partsSpec', width: 160,},
        {title: '仓库编码', field: 'warehouseCode', width: 160,},
        {title: '仓库名称', field: 'warehouseName', width: 160,},
        {title: '数量', field: 'qty', width: 80, },
        {title: '单价', field: 'price', width: 80, slots: {default: 'showStart'}},
        {title: '金额', field: 'amount', width: 80, slots: {default: 'showStart1'}},
        {title: '占用数量', field: 'takeUpQty', width: 80,},
        // {field: 'createTime', title: '创建时间', width: 150},
        // {title: '创建人', field: 'createBy', width: 150,},
      ]
    };
  },


  methods: {
    flushed() {

      this.$refs['table-m1'].commitProxy('reload');
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 搜索
    searchEvent() {
      this.formData.partsCode = this.formData1.partsCode
      this.formData.partsName = this.formData1.partsName
      this.formData.partsSpec = this.formData1.partsSpec
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },


    reloadTree() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    // 点击的树形 点
    handleNodeClick(node, data) {
      if(data){
        let id = data.data.id;
      if (data.level === 1) {
        this.formData.bigCategoryId = id;
        this.formData.smallCategoryId = null;
      } else {
        this.formData.smallCategoryId = id;
      }

      this.initTableList();
      this.flushed()
      }else{
        this.formData.bigCategoryId = null;
        this.formData.smallCategoryId = null;
        this.isShow=false
      this.flushed()
      this.isShow=true

      }
    },

    initTableList() {
      let tableOption = {}

      tableOption = {
        vue: this,
        tableRef: 'table-m2',
        tableName: 'basic_fault_code_list-m1',
        path: api.spPartsInv.getFramePageDataUrl,
        param: this.formData,
        method: 'post',
        columns: this.columns
      }

      this.vxeOption = initVxeTable(tableOption)
      this.flushed()
    },


    // 加载页面
    loadChildNode(node, resolve) {
      fetchTree({
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        resolve(
          data.data.map(item => {
            return {
              label: item.categoryName,
              id: item.id,
              leaf: Number(item.isChild) == 1 ? false : true,
            }
          })
        )
      });
    },

  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;
  max-height: 400px;
    overflow: hidden;
    overflow-y: scroll;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep body .dialog-style.list-dialog .el-dialog__body {
  background: #F1F5FB;
  padding: 8px 0px 1px !important;
  height: 575px;
}

// ::v-deep .el-dialog {

//   margin-top: 134px !important;

// }

body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

  z-index: 99999;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -40px !important;
  position: absolute !important;
  z-index: 9;
  background-color: #ffffff;
}

body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

  z-index: 99999;
}
</style>
